import { Link } from 'react-router-dom'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useHealthChecks } from '@/lib/health-checks'

export function HealthClusterTile() {
  const { data, isLoading } = useHealthChecks()

  if (isLoading) return <Skeleton className="h-32" />

  let up = 0
  let down = 0
  let autoDisabled = 0
  let disabled = 0
  let unknown = 0
  for (const c of data ?? []) {
    if (c.auto_disabled_at) { autoDisabled += 1; continue }
    if (!c.enabled) { disabled += 1; continue }
    if (c.port == null || !c.last_probe_at ||
        Date.now() - Date.parse(c.last_probe_at) > Math.max(120_000, c.interval_s * 3000)) {
      unknown += 1
      continue
    }
    if (c.last_status == null ||
        c.last_status < c.expect_min ||
        c.last_status > c.expect_max) {
      down += 1
    } else {
      up += 1
    }
  }
  const total = up + down + autoDisabled + disabled + unknown
  const active = up + down

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          <Link to="/health" className="hover:underline">Health checks</Link>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-semibold">
          {up}
          <span className="text-base text-muted-foreground font-normal">/{active} up</span>
        </div>
        <div className="text-xs text-muted-foreground">
          {total} check{total !== 1 ? 's' : ''} configured
          {down > 0 && <span className="text-destructive"> · {down} down</span>}
          {unknown > 0 && <span className="text-amber-500"> · {unknown} untested or stale</span>}
          {autoDisabled > 0 && <span className="text-amber-500"> · {autoDisabled} auto-disabled</span>}
        </div>
      </CardContent>
    </Card>
  )
}
